export const SET_RESULTS = 'set_results';
export const RESET_RESULTS = 'reset_results';
